import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_STORE_URL } from '../config/appStore';
import { trackAnalyticsEvent, trackPublicPage } from '../utils/analytics';

export function PublicAnalytics() {
    const { pathname } = useLocation();
    const previousPath = useRef<string>();
    useEffect(() => {
        // Ignore hash navigation and StrictMode effect replay.
        if (previousPath.current === pathname) return;
        previousPath.current = pathname;
        trackPublicPage();
    }, [pathname]);

    useEffect(() => {
        const trackLink = (event: MouseEvent) => {
            if (!(event.target instanceof Element)) return;
            const link = event.target.closest('a');
            if (!link) return;
            const url = new URL(link.href, window.location.origin);
            if (url.origin === window.location.origin && url.pathname === '/register') {
                trackAnalyticsEvent('signup_clicked');
            } else if (url.href === APP_STORE_URL) {
                trackAnalyticsEvent('app_store_clicked');
            }
        };
        document.addEventListener('click', trackLink, true);
        return () => document.removeEventListener('click', trackLink, true);
    }, []);
    return null;
}
